'use strict';

/**
 * @ngdoc filter
 * @name v6CoreModule.filter:translate
 * @function
 * @description
 * Drop in replacement for {@link
 * https://angular-translate.github.io/docs/#/api/pascalprecht.translate.filter:translate
 * ng-translate's translate filter}, meant to be used while we wait until migration
 * to the original translation library.
 */
angular
  .module('v6CoreModule')
  .filter('translate', ($locale, translate) => (key) => {
    const $translate = translate;

    return $translate.instant(key);
  });
